// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalendpointsGetSessionResponse } from './InternalendpointsGetSessionResponse';
import {
  InternalendpointsGetSessionResponseFromJSON,
  InternalendpointsGetSessionResponseFromJSONTyped,
  InternalendpointsGetSessionResponseToJSON,
  InternalendpointsGetSessionResponseToJSONTyped,
} from './InternalendpointsGetSessionResponse';
import type { EndpointsError } from './EndpointsError';
import {
  EndpointsErrorFromJSON,
  EndpointsErrorFromJSONTyped,
  EndpointsErrorToJSON,
  EndpointsErrorToJSONTyped,
} from './EndpointsError';

/**
 *
 * @export
 * @interface InternalSessionsSessionIdGet200Response
 */
export interface InternalSessionsSessionIdGet200Response {
  /**
   *
   * @type {InternalendpointsGetSessionResponse}
   * @memberof InternalSessionsSessionIdGet200Response
   */
  data?: InternalendpointsGetSessionResponse;
  /**
   *
   * @type {Array<EndpointsError>}
   * @memberof InternalSessionsSessionIdGet200Response
   */
  errors?: Array<EndpointsError>;
}

/**
 * Check if a given object implements the InternalSessionsSessionIdGet200Response interface.
 */
export function instanceOfInternalSessionsSessionIdGet200Response(
  value: object,
): value is InternalSessionsSessionIdGet200Response {
  return true;
}

export function InternalSessionsSessionIdGet200ResponseFromJSON(
  json: any,
): InternalSessionsSessionIdGet200Response {
  return InternalSessionsSessionIdGet200ResponseFromJSONTyped(json, false);
}

export function InternalSessionsSessionIdGet200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalSessionsSessionIdGet200Response {
  if (json == null) {
    return json;
  }
  return {
    data:
      json['data'] == null
        ? undefined
        : InternalendpointsGetSessionResponseFromJSON(json['data']),
    errors:
      json['errors'] == null
        ? undefined
        : (json['errors'] as Array<any>).map(EndpointsErrorFromJSON),
  };
}

export function InternalSessionsSessionIdGet200ResponseToJSON(
  json: any,
): InternalSessionsSessionIdGet200Response {
  return InternalSessionsSessionIdGet200ResponseToJSONTyped(json, false);
}

export function InternalSessionsSessionIdGet200ResponseToJSONTyped(
  value?: InternalSessionsSessionIdGet200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: InternalendpointsGetSessionResponseToJSON(value['data']),
    errors:
      value['errors'] == null
        ? undefined
        : (value['errors'] as Array<any>).map(EndpointsErrorToJSON),
  };
}
